import { clearAuthUserData } from './clearAuthUserData';
import { deleteCookie } from './cookie';

export const logout = () => {
  clearAuthUserData();
  deleteCookie('authentication_result');
  window.location.href = '/auth/login?logout=true';
};
